import { connect } from 'react-redux';
import SessionTrackerView from './SessionTrackerView';
import selectors from '../../rootSelectors';
import { resolveUser, handleAuthenticationFailed, logUserOut, portalRedirect } from './userActions';

const mapStateToProps = state => ({
    userId: selectors.getUserId(state),
    userType: selectors.getUserType(state),
    authenticationFailed: selectors.getAuthenticationFailed(state),
});

const mapDispatchToProps = dispatch => ({
    resolveUser: () => {
        dispatch(resolveUser());
    },
    handleAuthenticationFailed,
    logUserOut,
    portalRedirect,
});

const SessionTrackerContainer = connect(mapStateToProps, mapDispatchToProps)(SessionTrackerView);

export default SessionTrackerContainer;
